import axios from "axios";
import apiService from "./apiService";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/task`;

export const getTaskByIdService = async (taskId) => {
  try {
    const response = await apiService.get(`${API_BASE_URL}/get_task_by_id/${taskId}`);
    return response.data;
  } catch (error) {
    console.error("Error getting task by id:", error);
    throw error;
  }
};

export const getAllTasksService = async (getToken, userId) => {
  try {
    const token = await getToken();
    const response = await axios.get(
      `${API_BASE_URL}/get_all_tasks/${userId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error getting all tasks:", error);
    throw error;
  }
};

export const getTaskByProjectIdService = async (getToken, projectId) => {
  try {
    const token = await getToken();
    const response = await axios.get(`${API_BASE_URL}/get_task_by_project_id/${projectId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error getting task by project id:", error);
    throw error;
  }
};

export const getTasksByDateRangeService = async (getToken, { startByDate, dueByDate }) => {
  try {
    const token = await getToken();
    const response = await axios.get(`${API_BASE_URL}/get_tasks_by_date_range/${startByDate}/${dueByDate}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting tasks by date:", error);
    throw error;
  }
};

export const getTasksByProjectIdService = async (getToken, projectId) => {
  try {
    const token = await getToken();
    const response = await axios.get(`${API_BASE_URL}/get_tasks_by_project_id/${projectId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting tasks by project id:", error);
    throw error;
  }
};

export const getTasksByProjectIdsService = async (getToken, projectIds) => {
  try {
    const token = await getToken();
    const response = await axios.get(`${API_BASE_URL}/get_tasks_by_project_ids/${projectIds}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting tasks by project id:", error);
    throw error;
  }
};

export const getTasksByCategoryService = async (category) => {
  try {
    // Notice: category is a string like "while-you-are-out" or "things-to-read"
    const response = await apiService.get(`${API_BASE_URL}/get_tasks_by_category_id/${category}`);
    return response;
  } catch (error) {
    console.error('Error fetching tasks by category:', error);
    throw error;
  }
};

export const updateTaskService = async (getToken, userId, task) => {
  try {
    const token = await getToken();
    const response = await axios.post(
      `${API_BASE_URL}/update_task`,
      { task, userId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating task:", error);
    throw error;
  }
};

export const createTaskService = async (getToken, userId, task) => {
  try {
    const token = await getToken();
    const response = await axios.post(
      `${API_BASE_URL}/create_task`,
      { task, userId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating task:", error);
    throw error;
  }
};

export const deleteTaskService = async (getToken, taskId) => {
  try {
    const token = await getToken();
    const response = await axios.post(
      `${API_BASE_URL}/delete_task`,
      { taskId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting task:", error);
    throw error;
  }
};

export const deleteTaskFileService = async (
  getToken,
  { fileId, vectorStoreId }
) => {
  try {
    const token = await getToken();
    const response = await axios.post(
      `${API_BASE_URL}/delete_file`,
      { fileId, vectorStoreId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error;
  }
};

export const getSingleTaskActionService = async (getToken, userId, assistantId, task, chatId, vectorStoreId) => {
  try {
    const token = await getToken();
    const response = await axios.post(`${API_BASE_URL}/get_single_task_action`, { 
      taskDetails: task,
      userId,  
      chatId,
      assistantId, 
      vectorStoreId 
    }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Error getting single task action:", error);
    throw error;
  }
};

export const getTaskActionsService = async (getToken, taskId) => {
  try {
    const token = await getToken();

    const response = await axios.get(
      `${API_BASE_URL}/get_task_actions/${taskId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting task actions:", error);
    throw error;
  }
};

// TODO: Pass the getToken function to the service
export const addTaskActionService = async (
  getToken,
  taskId,
  taskAction
) => {
  try {
    const token = await getToken();

    const response = await axios.post(
      `${API_BASE_URL}/add_task_action`, { taskId, taskAction },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding task action:", error);
    throw error;
  }
};

export const deleteTaskActionByTypeService = async (getToken, taskId, taskActionType) => {
  try {
    const token = await getToken();
    
    const response = await axios.delete(`${API_BASE_URL}/delete_task_action_by_type/${taskId}/${taskActionType}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting task action:", error);
    throw error;
  }
};
